import tw, { styled } from 'twin.macro';
import KontentImage from '../KontentImage/KontentImage';

const lineClampStyle = ($lineClamp: number) => `
  display: -webkit-box;
  -webkit-line-clamp: ${$lineClamp};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const StyledTag = styled.span`
  ${tw`font-inter font-semi-bold uppercase`}
  ${tw`text-tag-m`}
  ${tw`block`}
  ${tw`mb-2`}
`;

export const StyledCard = styled.div<{
  backgroundColor?: Queries.kontent_item_card_elements_background_color_enum | null;
}>`
  ${tw`relative`}
  ${tw`inline-flex flex-col`}
  ${tw`ease-in-out duration-300`}
  ${tw`rounded-xl`}
  ${tw`text-primary-p1`}
  ${tw`border-2 border-primary-p1 border-solid`}
  ${tw`[&:not(.not-clickable)]:hover:translate-y-[-15px]`}

  &.not-clickable {
    ${tw`pointer-events-none`}
    ${tw`border-0`}
  }

  &::after {
    ${tw`content-['']`}
    ${tw`absolute`}
    ${tw`rounded-xl`}
    ${tw`h-[8px] w-full`}
    ${tw`bottom-0`}
  }

  ${({ backgroundColor }) => {
    switch (backgroundColor) {
      case 'ghost_white':
        return tw`bg-ui-colours-ui1`;
      default:
        return tw`bg-neutrals-n1`;
    }
  }}
`;

export const StyledTitle = styled.h3`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-heading-s text-primary-p1`}
  ${tw`block`}
  ${tw`mb-2`}
  & .ais-Highlight-highlighted {
    ${tw`bg-primary-p2`}
    ${tw`text-neutrals-n1`}
  }
`;

export const StyledShortDescription = styled.p<{ $lineClamp?: number }>`
  ${tw`font-inter`}
  ${tw`text-body-s text-primary-p1`}
  ${tw`mb-3 md:mb-4`}
  & .ais-Highlight-highlighted {
    ${tw`bg-primary-p2`}
    ${tw`text-neutrals-n1`}
  }

  .not-clickable & {
    ${tw`mb-0`}
  }

  ${({ $lineClamp }) => $lineClamp && lineClampStyle($lineClamp)}
`;

export const StyledLinkText = styled.p`
  ${tw`font-inter font-semi-bold`}
  ${tw`text-tag-m text-secondary-s1`}
  ${tw`mt-auto`}

  .not-clickable & {
    ${tw`hidden`}
  }
`;

export const StyledContainer = styled.div`
  ${tw`py-4 px-3`}
  ${tw`flex-1`}
  ${tw`flex flex-col`}
  ${tw`text-left`}
`;

export const StyledImage = styled(KontentImage)`
  ${tw`rounded-t-[0.625rem]`}
  ${tw`w-full`}
`;

export const StyledHeaderContainer = styled.div`
  ${tw`flex justify-between items-center`}
  ${tw`mb-2`}
`;

export const StyledRichTextDescription = styled.div<{ $lineClamp?: number }>`
  ${tw`font-inter`}
  ${tw`text-body-s text-primary-p1`}
  ${tw`mb-3 md:mb-4`}

  p {
    ${tw`pb-2`}
    & .ais-Highlight-highlighted {
      ${tw`bg-primary-p2`}
      ${tw`text-neutrals-n1`}
    }
  }

  ul {
    ${tw`list-disc`}
  }

  ol {
    ${tw`list-decimal`}
  }

  ol,
  ul {
    ${tw`pl-3`}
    li {
      ${tw`pl-1 pb-2`}
    }
  }

  ${({ $lineClamp }) => $lineClamp && lineClampStyle($lineClamp)}
`;
